<template>
    <div class="InfluencerProfileChannelsTab">
        <div v-if="!selectedChannel" class="font-thin text-xl text-gray-500 text-center">
            Influenten har endnu ingen medier tilknyttet
        </div>

        <div v-else class="mt-2">
            <ResponsiveGrid overwrite-style="display: flex;justify-content: center;gap: 50px;" :columns="{ default: 1, lg: 2, xl: 3 }" gap="20px" class="mb-5">
                <button
                    v-for="channel in channels"
                    :key="channel.id"
                    v-prevent-click-focus=""
                    :name="channel.platform.slug"
                    :class="{ active: isSelected(channel) }"
                    class=""
                    @click="selectedChannel = channel"
                >
                    <!--
                    <span class="InfluencerProfile__channels__channel__icon m-r-lg">
                        <platform-icon :platform="channel.platform"></platform-icon>
                    </span>
                    -->
                    <span v-text="
                        channel.platform.name === 'Instagram Business'
                            ? 'Instagram'
                            : channel.platform.name
                    " />
                    <!--
                    <span class="flex-1 text-left">
                        <span class="InfluencerProfileChannelsTab__channel__label">
                            Navn
                        </span>
                        <a
                            class="InfluencerProfileChannelsTab__channel__value"
                            :href="'/'+channel.resource_url"
                            target="_blank"
                            @click.stop=""
                        >
                            <span class="break-all" v-text="channel.resource_name" />
                            <span class="fa fa-external-link" />
                        </a>
                    </span>
                    <span class="flex-1 text-right">
                        <span
                            class="InfluencerProfileChannelsTab__channel__label"
                            v-text="channel.platform.reach_name"
                        />
                        <span
                            class="InfluencerProfileChannelsTab__channel__value"
                            v-text="channel.reach"
                        />
                    </span>
                    <span class=" InfluencerProfileChannelsTab__channel__radio">
                        <CheckInput type="radio" :checked="isSelected(channel)" class="ml-4" />
                    </span>
                    -->
                </button>
            </ResponsiveGrid>

            <div style="width: 100vw;margin-left: calc((-100vw + 100%) / 2);" class="bg-white">
                <div class="container">
                    <ChannelStatistics :channel="selectedChannel" />
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';
@import '~dashboard-less/spark/utilities';

.InfluencerProfileChannelsTab__channel {
    @apply flex items-center shadow-md;

    margin: 0 !important;

    a {
        color: inherit;
        text-decoration: none !important;
    }
}

.InfluencerProfileChannelsTab__channel.active,
.InfluencerProfileChannelsTab__channel:hover {
    border-width: 2px;
    border-color: @brand-primary;
    padding: 18px;
}

.InfluencerProfileChannelsTab__channel__label {
    @apply block font-thin mb-2 text-gray-600;
}

.InfluencerProfileChannelsTab__channel__value {
    @apply font-medium mb-2 text-gray-900;
}

.InfluencerProfileChannelsTab__channel .PlatformIcon {
    @apply text-3xl;
}
</style>

<script type="text/babel">
import ChannelStatistics from 'dashboard-js/components/influencers/ChannelStatistics'
import CheckInput from 'dashboard-js/components/utilities/CheckInput'
import PreventClickFocus from 'dashboard-js/directives/PreventClickFocus'
import ResponsiveGrid from 'dashboard-js/components/ResponsiveGrid'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'

export default {
    components: { CheckInput, ChannelStatistics, ResponsiveGrid },

    directives: { PreventClickFocus },

    mixins: [RestoreOnPageBack],

    props: ['channels', 'preselect'],

    data() {
        return {
            selectedChannel: null,
        }
    },

    created() {
        this.onPageVisit(() => {
            if (this.channels.length > 0) {
                this.selectedChannel = this.preselect ? this.preselect : this.channels[0]
            }
        })
    },

    beforeDestroy() {
        this.saveState()
    },

    methods: {
        isSelected(channel) {
            return channel.id === this.selectedChannel.id
        },
    },
}
</script>
